<template>
    <section id="bypasses" class="bypasses__section mt-2 mb-2">
        <div class="container-fluid">
            <div class="row" v-if="bypasses">
                <div class="col-sm-2 col-12 text-center" v-for="bypasse in bypasses"
                :key="bypasse.id">
                    <h6>{{ bypasse.geofence }}<br> {{ bypasse.services }}</h6>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "sust",
  data() {
    return {
      bypasses: undefined,
    };
  },
  created() {
    this.plain
      .get(`/bypasses`)
      .then((response) => {
        if (response.data.length !== 0) {
          this.bypasses = response.data;
        } else {
          this.bypasses = [];
        }
        // console.log(this.bypasses);
      })
      .catch((err) => {
        this.bypasses = [];
        console.log(err);
      });
  },
};
</script>

<style lang="scss" scoped>
.bypasses__section{
    background-image: url("/bg1.svg");
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: cover;
    height: 45vh;
    .container-fluid{
        height: 100%;
        .row{
            height: 100%;

            .col-sm-2{
                display:flex;
                justify-content: center;
                align-items: center;

                h6{
                    color: white;
                    font-weight: 600;
                }

                h5{
                    color: white;
                }

                .color{
                    width: 30px;
                    height: 30px;
                    background-color: red;
                }
            }
        }
    }
}

</style>


